import { format, parseISO } from "date-fns";

import { DateSelectValue } from "./types";

export function formatDateSelectValueAsISODate(
  value?: DateSelectValue,
  isApproximateDate?: boolean
) {
  if (!value) {
    return null;
  }

  const { year, month, day } = value;

  if (!year || !month) return "";
  if (!isApproximateDate && !day) return "";

  // isApproximateDate we need to set day to 1 or it will
  // use day 0 and force the previous month
  const newDay = isApproximateDate ? 1 : day;

  return format(new Date(year, month - 1, newDay), "yyyy-MM-dd").toString();
}

export function parseISODateAsDateSelectValue(value: string) {
  try {
    const isoDate = parseISO(value);

    return {
      year: isoDate.getFullYear() || 0,
      month: isoDate.getMonth() + 1 || 0,
      day: isoDate.getDate() || 0,
    };
  } catch {
    return null;
  }
}

export function validateDateSegments(
  t: (str: string) => string,
  date: DateSelectValue | undefined,
  label: string,
  isApproximateDate?: boolean
) {
  const invalidSegments = [];

  if (!isApproximateDate && !date?.day) {
    invalidSegments.push(t("day"));
  }

  if (!date?.month) {
    invalidSegments.push(t("month"));
  }

  if (!date?.year) {
    invalidSegments.push(t("year"));
  }

  if (invalidSegments.length === 1) {
    return `${label}: ${invalidSegments[0]} is required`;
  }

  if (invalidSegments.length > 1) {
    const lastSegment = invalidSegments.slice(-1);
    const firstSegments = invalidSegments.slice(0, -1).join(", ");
    const joinedSegments = [firstSegments, lastSegment].join(`, ${t("and")} `);
    return `${label}: ${joinedSegments} ${t("are required")}`;
  }
}
